<template>
    <div class="button" :class="'button-' + type" :style="`width: ${width}; height: ${height};`" :disabled="disabled">
      <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.9668 14.813L18.2988 14.472L18.1389 14.7852L18.2774 15.1084L18.9668 14.813ZM15.9801 18.261L16.2173 17.5495L15.857 17.4294L15.547 17.6487L15.9801 18.261ZM21.1886 19.9971L20.9514 20.7087L22.5358 21.2368L21.878 19.7017L21.1886 19.9971ZM19.25 10.5C19.25 11.9316 18.9068 13.2808 18.2988 14.472L19.6348 15.1539C20.3481 13.7565 20.75 12.1741 20.75 10.5H19.25ZM10.5 1.75C15.3325 1.75 19.25 5.66751 19.25 10.5H20.75C20.75 4.83908 16.1609 0.25 10.5 0.25V1.75ZM1.75 10.5C1.75 5.66751 5.66751 1.75 10.5 1.75V0.25C4.83908 0.25 0.25 4.83908 0.25 10.5H1.75ZM10.5 19.25C5.66751 19.25 1.75 15.3325 1.75 10.5H0.25C0.25 16.1609 4.83908 20.75 10.5 20.75V19.25ZM15.547 17.6487C14.1211 18.6574 12.3808 19.25 10.5 19.25V20.75C12.7012 20.75 14.7423 20.0553 16.4133 18.8733L15.547 17.6487ZM15.743 18.9725L20.9514 20.7087L21.4258 19.2856L16.2173 17.5495L15.743 18.9725ZM21.878 19.7017L19.6562 14.5175L18.2774 15.1084L20.4992 20.2926L21.878 19.7017Z" fill="white"/>
      </svg>
      {{ title }}
    </div>
</template>

<script>
export default {
  name: 'app-button-comment',
  props: {
    title: String,
    type: String,
    width: {
      type: String,
      default: '160px'
    },
    height: {
      type: String,
      default: '40px'
    },
    hasPlayIcon: Boolean,
    disabled: Boolean
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.button {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $font_color_alt;
  border-radius: 3px;
  padding: 10px 15px;
  transition: .3s;
  cursor: pointer;
  user-select: none;
  font-family: $font_main;

  svg {
    margin-right: 8px;
  }
}

.button-main {
  background: $button_color;
  box-shadow: 0 2px 2px #C6523B;

  &[disabled] {
    background: $color_deactive;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0px 4px 4px rgba(128, 37, 15, 0.54);
  }
}

.button-second {
  background: $button_color_second;
  box-shadow: 0px 2px 2px #4C095C;

  &[disabled] {
    background: $color_deactive;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0 4px 4px rgba(44, 4, 48, 0.54);
  }
}

.button-third {
  background: $button_color_third;
  box-shadow: 0 2px 2px #13557C;

  &[disabled] {
    background: $color_deactive;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0 4px 4px #0E476A;
  }
}

.button-fourth {
  background: $button_color_fourth;
  box-shadow: 0 2px 2px #557428;

  &[disabled] {
    background: $color_deactive;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0 4px 4px #557428;
  }
}

.button-alt {
  background: $color_main;
  color: $font_color_second;
  border: 1px solid $font_color_second;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.42);

  &[disabled] {
    color: $color_deactive;
    border: 1px solid $color_deactive;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.45);
  }
}

.play-icon {
  margin-left: 8px;
}
</style>
